<mat-toolbar matDialogTitle class="header accent-700 p-24">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <div class="mt-8">Alterar convênio</div>
        <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<div mat-dialog-content class="p-12 pb-5 m-0">

    <div fxLayout="column">

        <div fxLayout="row" fxLayoutGap="10">
            <mat-form-field fxFlex="100" class="mr-12" appearance="outline">
                <mat-label>Convênio</mat-label>
                <input matInput [matAutocomplete]="autoInsuranceF" [formControl]="insuranceControl" autocomplete="off"
                    type="search" />

                <mat-autocomplete autoActiveFirstOption #autoInsuranceF="matAutocomplete" autoActiveFirstOption
                    [displayWith]="displaySimpleFn">
                    <mat-option *ngFor="let insurance of insuranceList" [value]="insurance">
                        <p *ngIf="insurance">
                            {{ insurance.name }}
                        </p>
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="insuranceControl.hasError('required')">
                    Campo é obrigatório
                </mat-error>
                <mat-error *ngIf="insuranceControl.hasError('incorrect')">
                    Campo inválido
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10">

            <button [disabled]="insuranceControl.invalid" *ngIf="!progress" color="primary" mat-stroked-button
                mat-stroked-button (click)="changeInsurance()">
                Confirmar
                <span class="material-icons">swap_vert</span>
            </button>

            <button mat-button fxLayout="row" fxLayoutAlign="center" *ngIf="progress">

                <div fxLayoutAlign="space-evenly center">
                    <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
                    <p>Processando, aguarde...</p>
                </div>
            </button>

        </div>

    </div>

</div>